import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import MainWrap from './containers/MainWrap';
import Home from './containers/Home';
import PatientEnroll from './containers/PatientEnroll';
import PharmaEnroll from './containers/PharmaEnroll';
import HPSEnroll from './containers/HPSEnroll';
import PatientReplace from './containers/PatientReplace';
import HPSReplace from './containers/HPSReplace';
import PharmaReplace from './containers/PharmaReplace';
import PrintCard from './containers/PrintCard';
import MetaComponent from './components/MetaTags';

const App = () => (
  <Router>
    <main>
      <Switch>
        <Route exact path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)?" render={ props => {
          const data = {
            '@context': 'http://schema.org',
            '@type': 'Product',
            name: 'Takeda Oncology Co-Pay Assistance Program',
            image: '/images/takeda-logo.png',
            description: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication',
          };
          return (
            <MainWrap>
              <MetaComponent
                title="Takeda Oncology Co-Pay Assistance Program"
                metas={ [{ name: 'robots', content: 'index, follow' },
                  { name: 'description', content: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication' },
                  { name: 'keywords', content: 'ALUNBRIG financial assistance, ICLUSIG financial assistance, NINLARO financial assistance. ALUNBRIG Co-Pay assistance, ICLUSIG Co-Pay assistance, NINLARO Co-Pay assistance,Co-pay program, $0 Takeda Oncology, Copay card, Co-Pay card, copay assistance, Takeda Oncology Co-pay, Takeda Oncology financial assistance' }] }
                ogMetas={ [{ property: 'og:title', content: 'Takeda Oncology Co-Pay Assistance Program' },
                  { property: 'og:site_name', content: 'Takeda Oncology Co-Pay Assistance Program' },
                  { property: 'og:url', content: 'https://www.takedaoncologycopay.com/' },
                  { property: 'og:image', content: 'https://www.takedaoncologycopay.com/images/takeda-logo.png' },
                  { property: 'og:type', content: 'product' },
                  { property: 'og:description', content: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication' }] }
                canonicalLink="/"
                jsonLd={ data }
              />
              <Home { ...props } />
            </MainWrap>
          );
        } }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/patient/enroll/:step" render={ props => (
          <MainWrap>
            <PatientEnroll { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/patient/replace/:step?" render={ props => (
          <MainWrap>
            <PatientReplace { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/pharmacist/enroll/:step?" render={ props => (
          <MainWrap>
            <PharmaEnroll { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/pharmacist/replace/:step?" render={ props => (
          <MainWrap>
            <PharmaReplace { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/hps/enroll/:step?" render={ props => (
          <MainWrap>
            <HPSEnroll { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/hps/replace/:step?" render={ props => (
          <MainWrap>
            <HPSReplace { ...props } />
          </MainWrap>
        ) }
        />
        <Route path="/print-card/:groupID/:cardID/:cardBin/:cardPcn?" render={ props => (
          <PrintCard { ...props } />
        ) }
        />
        <Route path="/casemanagers/:environment(alunbrig|fruzaqla|iclusig|mimrylo|ninlaro)/hps/enroll/:step?" render={ props => {
          const data = {
            '@context': 'http://schema.org',
            '@type': 'Product',
            name: 'Takeda Oncology Co-Pay Assistance Program',
            image: '/images/takeda-logo.png',
            description: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication',
          };
          return (
            <MainWrap>
              <MetaComponent
                title="Takeda Oncology Co-Pay Assistance Program"
                metas={ [{ name: 'robots', content: 'noindex, nofollow' },
                  { name: 'description', content: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication' },
                  { name: 'keywords', content: 'ALUNBRIG financial assistance, ICLUSIG financial assistance, NINLARO financial assistance. ALUNBRIG Co-Pay assistance, ICLUSIG Co-Pay assistance, NINLARO Co-Pay assistance,Co-pay program, $0 Takeda Oncology, Copay card, Co-Pay card, copay assistance, Takeda Oncology Co-pay, Takeda Oncology financial assistance' }] }
                ogMetas={ [{ property: 'og:title', content: 'Takeda Oncology Co-Pay Assistance Program' },
                  { property: 'og:site_name', content: 'Takeda Oncology Co-Pay Assistance Program' },
                  { property: 'og:url', content: 'https://www.takedaoncologycopay.com/' },
                  { property: 'og:image', content: 'https://www.takedaoncologycopay.com/images/takeda-logo.png' },
                  { property: 'og:type', content: 'product' },
                  { property: 'og:description', content: 'Eligible commercially insured patients may pay as little as $0 for their Takeda Oncology medication' }] }
                canonicalLink="/"
                jsonLd={ data }
              />
              <HPSEnroll { ...props } />
            </MainWrap>
          );
        } }
        />
        <Redirect from="/casemanagers" to="/casemanagers/ninlaro/hps/enroll/eligibility" />
        <Redirect from="*" to="/" />
      </Switch>
    </main>
  </Router>
);

export default App;
